export default {
  mainContainer: 'border-4! border-[#ac6e1b]! cursor-pointer',
  topContainer: 'flex! gap-2! items-center bg-[#FFF2E5] py-[16px]',
  warninIcon: 'text-[#ac6e1b]',
  topContainerTitle: 'text-[#663c01]! font-medium! text-xl!',
  topContainerSubtitle: 'text-[#663c01]! font-normal! text-md!',
  bottomContainerTitle: 'opacity-65 text-sm!',
};
